import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const BASE_ACCOUNT_LINKS = [
  { to: "/account", label: "Overview" },
  { to: "/account/profile", label: "Profile" },
  { to: "/account/activity", label: "Activity" },
  { to: "/account/listings", label: "My Listings" }
];

export default function AccountNav({ extraLinks = [] }) {
  const { role } = useAuth();
  const links = [...BASE_ACCOUNT_LINKS];

  if (role === "admin") {
    links.push({ to: "/admin/queue", label: "Approval Queue" });
  }

  links.push(...extraLinks);

  return (
    <nav className="account-nav" aria-label="account-navigation">
      {links.map((link) => (
        <NavLink key={link.to} to={link.to} end={link.to === "/account"}>
          {link.label}
        </NavLink>
      ))}
    </nav>
  );
}
